var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeploy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "rocket_launch_black_24dp_1_",
    "data-name": "rocket_launch_black_24dp (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9604",
    "data-name": "Group 9604"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39102",
    "data-name": "Rectangle 39102",
    width: 22,
    height: 22,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9606",
    "data-name": "Group 9606",
    transform: "translate(2 2.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9605",
    "data-name": "Group 9605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4777",
    "data-name": "Path 4777",
    d: "M5.6,13.7a2.694,2.694,0,0,0-1.908.792C2.63,15.554,2,20,2,20s4.446-.63,5.508-1.692A2.7,2.7,0,0,0,5.6,13.7Zm.639,3.339a9.141,9.141,0,0,1-1.953.684A8.819,8.819,0,0,1,4.97,15.77a.835.835,0,0,1,.63-.27.9.9,0,0,1,.639,1.539Zm9.639-4.554h0C21.6,6.761,19.694,2.306,19.694,2.306S15.239.4,9.515,6.122l-2.241-.45a1.827,1.827,0,0,0-1.629.495L2,9.821l4.5,1.926L10.253,15.5,12.179,20l3.645-3.645a1.812,1.812,0,0,0,.495-1.629ZM6.869,9.947,5.15,9.209,6.923,7.436l1.3.261A22.532,22.532,0,0,0,6.869,9.947Zm5.922,6.9-.738-1.719a21.459,21.459,0,0,0,2.241-1.35l.261,1.3ZM14.6,11.216a15.45,15.45,0,0,1-3.636,2.457L8.327,11.036A15.247,15.247,0,0,1,10.784,7.4C15,3.188,18.191,3.809,18.191,3.809S18.812,7,14.6,11.216ZM13.7,10.1a1.8,1.8,0,1,0-1.8-1.8A1.805,1.805,0,0,0,13.7,10.1Z",
    transform: "translate(-2 -2.001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeploy);
export default __webpack_public_path__ + "static/media/deploy.0a7a4f8d5e3265505ef101a5b890bc1b.svg";
export { ForwardRef as ReactComponent };